import EditPriceType from './EditPriceType.container';

export default EditPriceType;
